module.exports = __webpack_public_path__ + "media/fart-07.9c46cf9e.mp3";